import React, { useContext, useEffect } from 'react';
import { Route, Switch, Redirect, useHistory } from 'react-router-dom';
import { Profile } from './Profile';
import { Password } from './Password';

export const ProfileIndex = () => {
  return (
    <Switch>
      <Route path='/profile/change-password' component={Password} />
      <Route path='/' component={Profile} />
    </Switch>
  );
};
